import './App.css';
import AppRouter from './app/router';

function App() {
  return (
    <div className="App">
        <AppRouter />
    </div>
  );
}

export default App;
